import { h } from "vue";

import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { EntityType } from "@/stores/entity-store";
import { Role } from "@/stores/roles-store";
import { vnodeToHtml } from "@/utils";

import { createEntityExtension } from "../mystekz-linked-entities";
import { LinkedEntity } from "../mystekz-linked-entities";
import { RolesManager } from "./manager";

export type RoleEntity = LinkedEntity<"role", Role>;

let rolesManager: RolesManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getRolesManager = (baseUrl: string) => {
    if (!rolesManager) {
        rolesManager = new RolesManager(baseUrl);
    }
    return rolesManager;
};

export const RolesExtension = createEntityExtension(
    "role",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "roleDetails",
            hover: true,
            create: (_: Promise<RoleEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.ROLE,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "roleInsert",
        },
        prefix: "~",
    },
    getRolesManager,
    {
        label: "Roles",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-id-card",
            library: "primeicons",
        },
        group: "References",
    }
);
